import { ThemeUICSSObject } from '@apia/theme';

const transitions: ThemeUICSSObject = {
  '.mainMenu__animate': {
    transition: 'transform 150ms, opacity 150ms',
    transform: 'translateX(-1000px)',
    opacity: 0,
  },
  '.mainMenu-enter,\n.mainMenu-appear': {
    transform: 'translateX(-1000px)',
    opacity: 0,
  },
  '.mainMenu-enter-active,\n.mainMenu-appear-active': {
    transform: 'translateX(0)',
    opacity: 1,
  },
  '.mainMenu-enter-done,\n.mainMenu-appear-done': {
    transform: 'translateX(0)',
    opacity: 1,
  },
  '.mainMenu-exit': { opacity: 0 },
  '.mainMenu-exit-done': { transform: 'translateX(-1000px)', opacity: 0 },
  '.mainMenu-exit-active': { transform: 'translateX(-1000px)', opacity: 1 },
};

export default transitions;
